// @flow
import {
  COORDINATE_INPUT_DIALOG_TOGGLE,
  COORDINATE_INPUT_DIALOG_TOGGLE_INVALID,
  COORDINATE_INPUT_DIALOG_SET_GEOMETRY_FORMAT,
} from 'actions/coordinateInputDialog';

const INITIAL_STATE = {
  visible: false,
  invalid: false,
  geometryFormat: 'autodetect',
};

export default function reduce(
  state = INITIAL_STATE,
  { type, visible, invalid, geometryFormat }
) {
  switch (type) {
    case COORDINATE_INPUT_DIALOG_TOGGLE:
      return {
        ...state,
        visible,
      };

    case COORDINATE_INPUT_DIALOG_TOGGLE_INVALID:
      return {
        ...state,
        invalid,
      };

    case COORDINATE_INPUT_DIALOG_SET_GEOMETRY_FORMAT:
      return {
        ...state,
        geometryFormat,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/coordinateInputDialog.js